"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const Util_1 = __importDefault(require("../../Util"));
class Pillars extends THREE.Object3D {
    constructor() {
        super();
        this.petals = [];
        this._create();
    }
    draw() {
        this.petals.forEach((petal, i) => {
            let delay = i * 0.07;
            if (delay > 0.5)
                delay = 0.5;
            gsap_1.gsap.delayedCall(i * 0.07, () => {
                petal.draw();
            });
        });
    }
    hide() {
        this.petals.forEach(petal => {
            petal.hide();
        });
    }
    _create() {
        posArr.forEach((pos, i) => {
            const size = 1.5 + i / 4;
            const petal = new Petal(size, size);
            petal.position.set(pos.x, pos.y, pos.z);
            this.add(petal);
            this.petals.push(petal);
        });
    }
}
exports.default = Pillars;
class Petal extends THREE.Object3D {
    constructor(width = 1, height = 1) {
        super();
        this.vs = `
      varying float v_z;
    
      #define PI 3.14159265359
      uniform float u_offset;
      uniform float u_progress;
      uniform float u_direction;
      uniform float u_time;
      uniform float u_waveIntensity;

      void main() {
    
        float maxDistance = distance(vec2(0.), vec2(0.8));
        float dist = distance(vec2(0.), uv-0.5);
        float activation = smoothstep(0., maxDistance, dist);
        float startAt = activation; // 시작 시간은 uv 위치에 따라 달라지게 구현 ( u_progress에서 타이밍을 다르게 조절 )
        float vertexProgress = smoothstep(startAt, 1., u_progress); // 위치값의 progress

        vec2 scale = vec2(1. + .5 * vertexProgress);
        vec3 pos = position;

        pos.xy *= scale;
        pos.z = (scale.x - 1.0) * 30.;
    
        v_z = pos.z / 10.;
    
        gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
      }
    `;
        this.fs = `
      precision mediump float;
      varying float v_z;
    
      void main() {
        
        float c = smoothstep(0.4, 0.0, v_z);
        vec3 color = vec3(c);
        gl_FragColor = vec4(color, 1.0);

      }
    `;
        this.width = width;
        this.height = height;
        this.wireframe = null;
        this.shape = null;
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_time: { value: 0.0 },
            u_offset: { value: 0 },
            u_direction: { value: 1 },
            u_waveIntensity: { value: 0.1 },
        };
        this._createShape();
    }
    draw() {
        gsap_1.gsap.to(this.uniforms.u_progress, {
            duration: 3,
            value: 0.6,
            ease: 'power2.inOut',
        });
        gsap_1.gsap.to(this.scale, {
            delay: 2.3,
            duration: 0.8,
            x: 0.6,
            z: 0.6,
            ease: 'power2.inOut',
        });
    }
    hide() {
        const duration = Util_1.default.random(1, 1.5);
        const delay = Util_1.default.random(0, 0.2);
        gsap_1.gsap.to(this.uniforms.u_progress, {
            delay,
            duration: duration,
            value: 0,
            ease: 'power1.inOut',
        });
        gsap_1.gsap.to(this.scale, {
            delay,
            duration: duration - 0.5,
            x: 1.3,
            z: 1.3,
            ease: 'power1.inOut',
        });
        gsap_1.gsap.to(this.position, {
            delay,
            duration: duration,
            z: -this.position.z / 2,
            ease: 'power1.inOut',
        });
    }
    update() {
    }
    _createShape() {
        const geo = new THREE.PlaneBufferGeometry(this.width, this.height, 16, 16);
        const mat = new THREE.ShaderMaterial({
            vertexShader: this.vs,
            fragmentShader: this.fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
            fog: false,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.shape.rotation.x = -Math.PI / 2;
        this.add(this.shape);
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
}
const posArr = [
    {
        x: 2,
        y: 0,
        z: 0,
    },
    {
        x: 1.8477590650225735,
        y: 0,
        z: -0.7653668647301796,
    },
    {
        x: 1.4142135623730951,
        y: 0,
        z: -1.414213562373095,
    },
    {
        x: 0.7653668647301797,
        y: 0,
        z: -1.8477590650225735,
    },
    {
        x: 1.2246467991473532e-16,
        y: 0,
        z: -2,
    },
    {
        x: -0.7653668647301795,
        y: 0,
        z: -1.8477590650225735,
    },
    {
        x: -1.414213562373095,
        y: 0,
        z: -1.4142135623730951,
    },
    {
        x: -1.8477590650225735,
        y: 0,
        z: -0.7653668647301798,
    },
    {
        x: -2,
        y: 0,
        z: -2.4492935982947064e-16,
    },
    {
        x: 2.7189233611099497,
        y: 0,
        z: -1.2678547852220983,
    },
    {
        x: 1.0260604299770064,
        y: 0,
        z: -2.819077862357725,
    },
    {
        x: -1.267854785222098,
        y: 0,
        z: -2.71892336110995,
    },
    {
        x: -2.819077862357725,
        y: 0,
        z: -1.0260604299770066,
    },
    {
        x: -3.1,
        y: 0,
        z: -3.5,
    },
    {
        x: -2.2,
        y: 0,
        z: -3.5,
    },
    {
        x: -1.3,
        y: 0,
        z: -3.5,
    },
    {
        x: -0.3999999999999999,
        y: 0,
        z: -3.5,
    },
    {
        x: 0.5,
        y: 0,
        z: -3.5,
    },
    {
        x: 1.4,
        y: 0,
        z: -3.5,
    },
    {
        x: 2.3000000000000003,
        y: 0,
        z: -3.5,
    },
    {
        x: 3.1999999999999997,
        y: 0,
        z: -3.5,
    },
    {
        x: -2.4,
        y: 0,
        z: -4.5,
    },
    {
        x: -1.5999999999999999,
        y: 0,
        z: -4.5,
    },
    {
        x: -0.7999999999999998,
        y: 0,
        z: -4.5,
    },
    {
        x: 4.440892098500626e-16,
        y: 0,
        z: -4.5,
    },
    {
        x: 0.8000000000000003,
        y: 0,
        z: -4.5,
    },
    {
        x: 1.6,
        y: 0,
        z: -4.5,
    },
    {
        x: 2.400000000000001,
        y: 0,
        z: -4.5,
    },
];
